var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/core-js/date/now", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "classnames", "debounce", "../Icon/Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/core-js/date/now"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("classnames"), require("debounce"), require("../Icon/Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.now, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.classnames, global.debounce, global.Icon);
    global.ScrollTop = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _now, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _classnames, _debounce, _Icon) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _now = _interopRequireDefault(_now);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _debounce = _interopRequireDefault(_debounce);
  _Icon = _interopRequireDefault(_Icon);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var easings = {
    linear: function linear(t) {
      return t;
    },
    easeInQuad: function easeInQuad(t) {
      return t * t;
    },
    easeOutQuad: function easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad: function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic: function easeOutCubic(t) {
      return --t * t * t + 1;
    },
    easeInOutCubic: function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart: function easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart: function easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart: function easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint: function easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint: function easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint: function easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
  };

  var ScrollTop = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(ScrollTop, _PureComponent);

    var _super = _createSuper(ScrollTop);

    function ScrollTop() {
      var _this;

      (0, _classCallCheck2.default)(this, ScrollTop);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
        hideButton: true
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScroll", function () {
        if (global.pageYOffset >= _this.props.showAtOffset && _this.state.hideButton === true) {
          _this.setState({
            hideButton: false
          });
        } else if (global.pageYOffset < _this.props.showAtOffset && _this.state.hideButton === false) {
          _this.setState({
            hideButton: true
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollToTop", function () {
        var startTime = (0, _now.default)();
        var documentHeight = global.document.documentElement.scrollHeight;
        var windowHeight = global.document.documentElement.clientHeight;
        var destinationOffsetToScroll = Math.round(documentHeight < windowHeight ? documentHeight - windowHeight : 0);

        var scrollMe = function scrollMe() {
          var time = Math.min(1, ((0, _now.default)() - startTime) / _this.props.scrollDuration);

          var timeFunction = easings[_this.props.scrollEasing](time);

          global.scroll(0, Math.ceil(timeFunction * (destinationOffsetToScroll - global.pageYOffset) + global.pageYOffset));

          if (global.pageYOffset === destinationOffsetToScroll) {
            return;
          }

          global.requestAnimationFrame(scrollMe);
        };

        scrollMe();
      });
      return _this;
    }

    (0, _createClass2.default)(ScrollTop, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.onScrollDebounce = (0, _debounce.default)(this.onScroll, 80);
        global.addEventListener('scroll', this.onScrollDebounce);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        global.removeEventListener('scroll', this.onScrollDebounce);
        this.onScrollDebounce.clear();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement("button", {
          "aria-hidden": true,
          tabIndex: "-1",
          onClick: this.scrollToTop,
          className: (0, _classnames.default)('scroll-top', [this.state.hideButton ? 'fade-out' : 'fade-in'])
        }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          className: "scroll-top__icon",
          name: "arte-icon--up2",
          size: "xsmall"
        }));
      }
    }]);
    return ScrollTop;
  }(_react.PureComponent);

  ScrollTop.propTypes = {
    scrollDuration: _propTypes.default.number,
    scrollEasing: _propTypes.default.oneOf(['linear', 'easeInQuad', 'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic', 'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint', 'easeInOutQuint']),
    showAtOffset: _propTypes.default.number
  };
  ScrollTop.defaultProps = {
    scrollDuration: 1000,
    scrollEasing: 'easeInQuint',
    showAtOffset: 600
  };
  var _default = ScrollTop;
  _exports.default = _default;
});